import React, {useEffect} from 'react';
import '../styles/Home.scss';
import FormScore from "../components/FormScore";
import {CategoryList} from "../components/CategoryList";
import {Register} from "../components/Register";
import api from "../api/axiosInstance";
import {AgGrid} from "../components/AgGrid";
import {GeneralChart} from "../components/GeneralChart";

function Home() {

    return (
        <div id="Home">
            <GeneralChart/>
        </div>
    );
}

export default Home;
